import { render, staticRenderFns } from "./SkribbleFrameworkAgreement.vue?vue&type=template&id=114fb247&scoped=true&"
import script from "./SkribbleFrameworkAgreement.vue?vue&type=script&lang=js&"
export * from "./SkribbleFrameworkAgreement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "114fb247",
  null
  
)

export default component.exports